import React, { useState, useEffect } from 'react';
import AddPlansModal from './AddPlansModal';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function PlansList() {
  const [plans, setPlans] = useState([]);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(`${API_URL}/plans`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (response.ok && Array.isArray(data)) {
          setPlans(data);
        } else {
          setPlans([]);
        }
      } catch (error) {
        setPlans([]);
      }
    };
    fetchPlans();
  }, [token]);

  const handleOpenAddModal = () => setAddModalVisible(true);
  const handleCloseAddModal = () => setAddModalVisible(false);

  const handleAddPlan = () => {
    window.location.reload();
    handleCloseAddModal();
  };

  return (
    <section className="dashboard-section">
      <h3>Planos</h3>
      {plans.length > 0 ? (
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Valor</th>
              <th>Qtd. Empresas</th>
              <th>Descrição</th>
              <th>Status</th>
              <th>Criado em</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((plan, index) => (
              <tr key={plan.id} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                <td>{plan.id}</td>
                <td>{plan.nome}</td>
                <td>R$ {plan.valor}</td>
                <td>{plan.qtd_companies}</td>
                <td>
                  <ul>
                    {plan.descricao && (() => {
                      let descObj = plan.descricao;
                      if (typeof descObj === 'string') {
                        try {
                          descObj = JSON.parse(descObj);
                        } catch {
                          descObj = {};
                        }
                      }
                      return Object.entries(descObj).map(([key, value]) => (
                        <li key={key}>
                          {key.replace(/_/g, ' ')}: {value === 1 ? 'Sim' : 'Não'}
                        </li>
                      ));
                    })()}
                  </ul>
                </td>
                <td>{plan.status ? 'Ativo' : 'Inativo'}</td>
                <td>{plan.created_at ? new Date(plan.created_at).toLocaleString() : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nenhum plano encontrado.</p>
      )}
      <div style={{ marginTop: '10px', textAlign: 'right' }}>
        <button onClick={handleOpenAddModal} title="Adicionar Plano" className="button-style">
          +
        </button>
      </div>
      {addModalVisible && (
        <AddPlansModal
          visible={addModalVisible}
          onClose={handleCloseAddModal}
          onAdd={handleAddPlan}
        />
      )}
    </section>
  );
}

export default PlansList;